/**
 * @generated SignedSource<<c1663f17d9b275156589e28a38c66c01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StorecastDeviceScheduleItemWeekday = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY";
import { FragmentRefs } from "relay-runtime";
export type StorecastScreenAdminSchedule_StorecastScreen$data = {
  readonly id: string;
  readonly scheduledStorecasts: ReadonlyArray<{
    readonly endAt: string;
    readonly id: string;
    readonly startAt: string;
    readonly storecast: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly weekdays: ReadonlyArray<StorecastDeviceScheduleItemWeekday>;
  }>;
  readonly " $fragmentType": "StorecastScreenAdminSchedule_StorecastScreen";
};
export type StorecastScreenAdminSchedule_StorecastScreen$key = {
  readonly " $data"?: StorecastScreenAdminSchedule_StorecastScreen$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastScreenAdminSchedule_StorecastScreen">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastScreenAdminSchedule_StorecastScreen",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastDeviceSetDashboardScheduleItem",
      "kind": "LinkedField",
      "name": "scheduledStorecasts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "storecast",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weekdays",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StorecastScreen",
  "abstractKey": null
};
})();

(node as any).hash = "b106be3c79359b021c35ea9a8b8bb559";

export default node;
